var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hamburger",class:{ 'active' : _vm.isBurgerActive },attrs:{"id":"burger"},on:{"click":function($event){$event.stopPropagation();return _vm.toggle.apply(null, arguments)}}},[_vm._t("default",function(){return [_vm._m(0)]})],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"type":"button","title":"Menu"}},[_c('i',{staticClass:"fa fa-bars",attrs:{"aria-hidden":"true"}})])
}]

export { render, staticRenderFns }